import styled from 'styled-components';
import { mediaQueries, size, colors } from '@everlywell/leaves';

const colorMap = {
  Primary: colors.white,
  Secondary: colors.teal1,
};

// 64px of total vertical spacing between sections on mobile, 128px on desktop
export const SectionWrapper = styled.section.attrs(props => ({
  backgroundColor: props.backgroundColor,
}))`
  position: relative;
  padding: ${size.xl1}px 0;
  background-color: ${({ backgroundColor }) => colorMap[backgroundColor]};

  ${mediaQueries.forTabletHorizontalUp} {
    padding: ${size.xl4}px 0;
  }
`;
